export default __webpack_public_path__ + "static/yassine-khalfalli-river-ee223c16bc646f8acb5587a9e9314f5d.jpg";